import { SimpleMap } from "../../../js/components/simple-map";

class ReactSimpleMap extends SimpleMap {
    constructor(targetDiv, initState) {
        super(targetDiv)
        this.initState = initState
    }

    configureFYHSettings(searchString) {
        // update states that are in site data onto the us map
        window.century.settings.searchRegionStates.forEach((state) => {
            let selectedState = this.initState == state.StateCode
            let pageUrl = searchString.length ? state.RelativeURL + searchString : state.RelativeURL
            this.map.mapdata.state_specific[state.StateCode] = {
                selectable: !selectedState,
                color: selectedState ? '#4a104a' : '#ffffff',
                hover_color: "#4a104a",
                url: !selectedState ? pageUrl : '' 
            }
        });
    }
}

export {ReactSimpleMap}